import {
  IAccuracyClaim,
  IAccuracyClaimResponse,
} from 'src/app/interfaces/iaccuracy-feedback';

/** Maps the API's snake_case claims onto the view model, tolerating gaps. */
export const toAccuracyClaims = (
  claims?: IAccuracyClaimResponse[] | null
): IAccuracyClaim[] => {
  if (!Array.isArray(claims)) return [];

  return claims.map((claim) => ({
    originalClaim: claim?.original_claim ?? '',
    normalizedClaim: claim?.normalized_claim ?? '',
    appliedFact: claim?.applied_fact ?? '',
  }));
};
